import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import moment from "moment-timezone";
import Swal from "sweetalert2";
import Filter from "../../../helpers/Filter";
import Configs from "../../../Configs";

class ReportActivities extends Component {
  state = {};

  viewProfile = (report) => {
    const countTransactions = report.get("countTransactions");
    const timeTaken = report.get("takenRunTime");
    let html = `
            <h4>Time Taken: ${Filter.millisToMinutesAndSeconds(timeTaken)}</h4>
        `;
    const tables = Object.keys(countTransactions);
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      if (countTransactions[table] == undefined || !countTransactions[table]) {
        continue;
      }
      let tableHtml = "";
      if (
        countTransactions[table].used !== undefined &&
        countTransactions[table].used
      ) {
        const useds = countTransactions[table].used;
        let tableUsedHtml = "";
        for (let usedI = 0; usedI < useds.length; usedI++) {
          const used = useds[usedI];
          tableUsedHtml += `
                        <tr>
                            <td>${usedI + 1}</td>
                            <td>${used.rss}</td>
                            <td>${used.heapTotal}</td>
                            <td>${used.heapUsed}</td>
                            <td>${used.external}</td>
                        </tr>
                    `;
        }
        tableHtml += `<table id="table" border=1 style="width: 100%">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>RSS</th>
                                <th>Heap Total</th>
                                <th>Heap Used</th>
                                <th>External</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableUsedHtml}
                        </tbody>
                    </table>
                `.trim();
      }
      html += `
                <div style="text-align: left;">
                    <h5>Request Class: ${table}</h5>
                    <p>Total Records: ${
                      countTransactions[table].totalRequest || 0
                    }</p>
                </div>${tableHtml}
            `;
    }
    Swal.fire({
      title: "The Profiler",
      html: html,
    });
  };

  formatActivityStatus = (status) => {
    switch (status) {
      case 1:
        return <span className="label label-warning">In Queue</span>;
        break;
      case 2:
        return <span className="label label-success">Completed</span>;
        break;
      default:
        return <span className="label label-danger">Canceled</span>;
        break;
    }
  };

  render() {
    const activities = [...this.props.activities];
    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title">Activity Removed</h3>
          <div className="box-tools">
            <button
              className="btn btn-default btn-sm"
              onClick={this.props.refresh}
            >
              <i className="fa fa-refresh"></i>
              Refresh
            </button>
          </div>
        </div>
        <div className="box-body">
          <div className="col-xs-12 col-md-12 col-lg-12 table-responsive no-padding">
            <table className="table table-hover reportTable">
              <tbody>
                <tr>
                  <th></th>
                  <th>Report type</th>
                  <th>Request date</th>
                  <th>Date range</th>
                  <th>Sent to Email</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                {activities.map((value, key) => {
                  const periods = [...value.get("periods")];
                  const sentTo = value.get("sendTo");
                  const status = value.get("status");
                  const isBigSummary = value.get("isBigSummary");

                  let sendUrl = value.get("sendUrl");
                  let summaryUrl = value.get("summaryFile");
                  if (sendUrl !== undefined && sendUrl) {
                    sendUrl = sendUrl
                      ? sendUrl.replace(
                          Configs.abossUrl + "/page?to=/",
                          "/"
                        )
                      : "/";
                    sendUrl = sendUrl
                      ? sendUrl.replace(
                          "https://gcaboss.foodzaps.com/page?to=/",
                          "/"
                        )
                      : "/";
                    sendUrl = sendUrl.split("&");
                    sendUrl = sendUrl[0] ? sendUrl[0] : "/";
                  }
                  if (isBigSummary) {
                    summaryUrl = value.get("summaryFile");
                  }
                  return (
                    <tr key={key}>
                      <td>
                        {
                          <a onClick={() => this.viewProfile(value)}>
                            Profiler
                          </a>
                        }
                      </td>
                      <td>{value.get("reportType")}</td>
                      <td>{moment(value.createdAt).format("LLL")}</td>
                      <td>
                        {periods.map((period, key) => {
                          const ranges = { ...period.range };
                          return (
                            <p key={key}>{`${period.name}: ${moment(
                              ranges.start
                            ).format("LLL")} - ${moment(ranges.end).format(
                              "LLL"
                            )}`}</p>
                          );
                        })}
                      </td>
                      <td>
                        {sentTo !== undefined && sentTo
                          ? sentTo
                          : status === 1
                          ? "Pending..."
                          : ""}
                      </td>
                      <td>{this.formatActivityStatus(status)}</td>
                      <td className="action">
                        {sendUrl !== undefined && sendUrl && sendUrl !== "" ? (
                          <NavLink exact to={sendUrl}>
                            View
                          </NavLink>
                        ) : null}
                        {summaryUrl !== undefined &&
                        summaryUrl &&
                        summaryUrl !== "" ? (
                          <a target="_blank" href={summaryUrl}>
                            Summary
                          </a>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default ReportActivities;
